import { API_URL } from '@constants';
import { getAbsoluteCurrentUrl } from './get-absolute-current-url';

export const getAbsoluteApiUrl = () => `${getAbsoluteCurrentUrl()}/${API_URL}`;
